import { objectUtils } from './object-utils';

export class UrlBuilder {
  public static build<TParams, TQParams = {}>(
    path: string,
    params: TParams,
    queryParams?: Partial<TQParams>,
  ): string {
    const url = UrlBuilder.getUrl(path, params);
    const queryString = UrlBuilder.getQueryString(queryParams);

    return queryString
      ? `${url}?${queryString}`
      : url;
  }

  private static getUrl<TParams>(
    path: string,
    params: TParams,
  ): string {
    let url = path;
    const paramsArray = Object.entries(params) as Array<[keyof TParams, any]>;
    for (const [paramName, value] of paramsArray) {
      // For example, /:projectId\??/. JS eats one backslash while parsing literal.
      const paramRegex = new RegExp(`:${String(paramName)}(\\(.*?\\))?\\??`);
      if (!paramRegex.test(path)) {
        continue;
        // throw new Error(`Parameter ${paramName} is missing in path`);
      }

      url = url.replace(paramRegex, value);
    }

    return url;
  }

  private static getQueryString<TQParams>(queryParams?: Partial<TQParams>): string {
    return objectUtils.toQueryString(queryParams);
  }
}
